export const campaign = {
  campaignId: 'd723297b-1d42-4903-9572-c9c24287d2e4',
  programId: '9f853e7c-0a25-402c-98e5-2cf544dbd9d6',
  title: 'test 5',
  shortDescription: 'desc 5',
  longDescription: 'desc 5',
  merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
  startDate: '2023-06-26',
  endDate: '2023-06-30',
};

export const campaignList = {
  paging: {
    total: 10,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  campaigns: [
    {
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      programId: '9f853e7c-0a25-402c-98e5-2cf544dbd9d6',
      title: 'test one',
      shortDescription: 'test one desc',
      longDescription: 'test one desc',
      merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
      startDate: '2020-06-28',
      endDate: '3023-06-28',
    },
    {
      campaignId: '7a83d9f0-c35e-4d82-b176-37de4f66ecaf',
      programId: '9f853e7c-0a25-402c-98e5-2cf544dbd9d5',
      title: 'test two',
      shortDescription: 'test two desc',
      longDescription: 'test two desc',
      merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
      startDate: '2023-06-29',
      endDate: '3023-06-26',
    },
    {
      campaignId: '431f0f45-a012-43df-a96a-fa623ffb6fa7',
      programId: '9f853e7c-0a25-402c-98e5-2cf544dbd9d4',
      title: 'test three',
      shortDescription: 'test two desc',
      longDescription: 'test two desc',
      merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
      startDate: '2023-06-30',
      endDate: '3023-06-30',
    },
    {
      campaignId: '450686f8-a3c9-40fa-b857-8260170cc17b',
      programId: '9f853e7c-0a25-402c-98e5-2cf544dbd9d6',
      title: 'test four',
      shortDescription: 'test four desc',
      longDescription: 'test four desc',
      merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
      startDate: '2023-06-25',
      endDate: '1900-01-01',
    },
    {
      campaignId: 'd723297b-1d42-4903-9572-c9c24287d2e4',
      programId: '67853e7c-0a25-402c-98e5-2cf544dbd9d6',
      title: 'test five',
      shortDescription: 'test five desc',
      longDescription: 'test five desc',
      merchantId: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
      startDate: '2023-06-26',
      endDate: '2023-06-30',
    },
  ],
};
